module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-08-32-816.6b50b8ff.mp4";